// eslint-disable-next-line import/no-unresolved
import React, { Fragment } from "react";
import classNames from "classnames";

import "./input-field.scss";

const InputField = ({ attributes, modifier, events }) => {
  const { error, disabled, masked, sublabel } = modifier;
  const cnErrorExists = error ? "input-has-error" : "";
  const cnDisabled = disabled ? "disabled" : "";
  const cnMasked = masked ? "input-masking" : "";

  const { id, label, type, placeholder, maxLength, value, ...rest } = attributes;

  const inputType = type === "text" ? "text" : type;

  const { onChange, onFocus, onBlur } = events;

  return (
    <section
      className={`input-container ${classNames(cnErrorExists, cnDisabled)}`}
    >
      <div>
        <label htmlFor="id" id={`label-${id}`}>
          {label}
        </label>
      </div>
      <div className="input-wrapper">
        <Fragment>
          <input
            id={id}
            type={inputType}
            placeholder={placeholder}
            disabled={disabled}
            autoComplete="anyrandomstring"
            maxLength={maxLength}
            value={value}
            className={classNames(cnMasked)}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            {...rest}
          />
          {masked ? (
            <div className="masking">
              <span>{masked}</span>
            </div>
          ) : (
            ""
          )}
        </Fragment>
      </div>
      {error ? (
        <small className="has-error">{error}</small>
      ) : (
        <small className="no-error">{sublabel}</small>
      )}
    </section>
  );
};

InputField.defaultProps = {
  attributes: {},
  modifier: {},
  events: {},
};

export default InputField;
